import { ElementRef } from '@angular/core';
import { Directive, HostListener, Input } from '@angular/core';
import { NumberToWord } from 'src/services/NumberToWord';

@Directive({
  selector: '[numberToWords]'
})
export class NumberToWordsDirective {

  @Input() numberToWords: string = "";
  @Input() currency: string = "Niara";
  @Input() decimalCurrency: string = "Kobo";

  constructor() {

  }

  @HostListener('keyup', ['$event'])
  onKeyUp(event: any) {
    let n = new NumberToWord();
    n.currency = this.currency;
    n.decimalCurrency = this.decimalCurrency;
    let words = n.toWords(event.target.value);
    this.output(words);
  }

  output(words: any) {
    if (this.numberToWords) {
      let element: HTMLElement = document.getElementById(this.numberToWords) as HTMLElement;
      if(element.tagName === 'SELECT' || element.tagName == 'INPUT') {
        (<HTMLInputElement>document.getElementById(this.numberToWords)).value = words;
      }
      else{
        element.innerHTML = words;
      }
    }
    else {
      console.log(words);
    }
  }


}
